const googleFonts = require('google-fonts');

const fonts = {
  'Roboto': true,
  'Open Sans': true,
  'Lato': true,
  'Montserrat': true,
  'Oswald': true,
  'Raleway': true,
  'Merriweather': true,
  'Nunito': true,
  'Ubuntu': true,
  'Playfair Display': true,
  'Poppins': true,
  'Source Sans Pro': true,
  'Roboto Condensed': true,
  'Noto Sans': true,
  'Mukta': true,
  'Rubik': true,
  'Quicksand': true,
  'Work Sans': true,
  'Inconsolata': true,
  'Josefin Sans': true,
  'Fira Sans': true,
  'Karla': true,
  'Libre Baskerville': true,
  'PT Sans': true,
  'Arvo': true,
  'Cabin': true,
  'Dosis': true,
  'Heebo': true,
  'Lora': true,
  'Muli': true,
  'Bebas Neue': true,
  'Bitter': true,
  'Cairo': true,
  'Comfortaa': true,
  'Crimson Text': true,
  'Dancing Script': true,
  'Exo 2': true,
  'Fjalla One': true,
  'Hind': true,
  'Indie Flower': true,
  'Kanit': true,
  'Lobster': true,
  'Maven Pro': true,
  'Merriweather Sans': true,
  'Noto Serif': true,
  'Pacifico': true,
  'PT Serif': true,
  'Righteous': true,
  'Satisfy': true,
  'Slabo 27px': true,
  'Teko': true,
  'Titillium Web': true,
  'Varela Round': true,
  'Zilla Slab': true,
};

googleFonts.add(fonts);

export default fonts;